/*
 **  This component will be published in a separate package
 */
import React, { useState } from 'react'
import { Image, Text, Box } from 'grommet'
import { getUserColor, getUserInitials } from './utils'

// TODO
// 3 words name initials
// handle only alpha numeric chars

const GiftedAvatar = ({
  user = { name: null, avatar: null },
  onPress = null,
  avatarStyle = {},
  textStyle = {},
  ...props
}) => {
  const [avatarColor, setAvatarColor] = useState('')
  const renderAvatar = () => {
    if (typeof user.avatar === 'function') {
      return user.avatar()
    } else if (typeof user.avatar === 'string') {
      return (
        <Image src={{ uri: user.avatar }} style={defaultStyles.avatarStyle} />
      )
    } else if (typeof user.avatar === 'number') {
      return <Image src={user.avatar} style={defaultStyles.avatarStyle} />
    }
    return null
  }

  const renderInitials = () => {
    return (
      <Text style={defaultStyles.textStyle}>{getUserInitials(user.name)}</Text>
    )
  }

  if (!user.name && !user.avatar) {
    // render placeholder
    return <Box style={defaultStyles.avatarStyle} />
  }
  if (user.avatar) {
    return (
      <Box
        onClick={() => {
          const allProps = {
            user,
            onPress,
            avatarStyle,
            textStyle,
            ...props
          }
          onPress && onPress(allProps)
        }}>
        {renderAvatar()}
      </Box>
    )
  }

  if (!avatarColor) {
    setAvatarColor(getUserColor(user.name || ''))
  }

  return (
    <Box
      onPress={() => {
        const allProps = {
          user,
          onPress,
          avatarStyle,
          textStyle,
          ...props
        }
        onPress && onPress(allProps)
      }}
      style={defaultStyles.avatarStyle}>
      {renderInitials()}
    </Box>
  )
}

export default GiftedAvatar

const defaultStyles = {
  avatarStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    borderRadius: 20
  },
  textStyle: {
    color: '#fff',
    fontSize: 16,
    backgroundColor: 'transparent',
    fontWeight: '100'
  }
}
